import { types } from 'mobx-state-tree';
import PubSub from 'pubsub-js';
import keyboardjs from 'keyboardjs';

import { getWindowSize } from 'js/services/ResizeListener';
import { castEventToValue } from 'js/services/FormTools';
import WindowSize from './types/WindowSize';

function noop() {}
function shouldShowAssertion(showModal, modal) {
  return showModal && modal.windowSize.height < modal.contentHeight ? 'open' : 'closed';
}

export default types
  .model('ModalState', {
    contentHeight: 0,
    isOpen: false,
    windowSize: types.optional(WindowSize, {}),
  })
  .actions(self => {
    let windowResizeListener;
    let userCancel;
    let isShowing = false;

    return {
      afterCreate() {
        windowResizeListener = PubSub.subscribe('onResize', (msg, windowSize) => self.setWindowSize(windowSize));
        self.setWindowSize();
      },
      beforeDestroy() {
        keyboardjs.unbind('esc', userCancel);
        PubSub.unsubscribe(windowResizeListener);
      },
      setOnCancel(onCancel) {
        userCancel = onCancel || noop;
        keyboardjs.bind('esc', userCancel);
        return self;
      },
      displayUpdate(showModal) {
        isShowing = showModal;
        return self.updateVisibility(shouldShowAssertion(showModal, self));
      },
      setContentHeight(contentHeight) {
        self.contentHeight = castEventToValue(contentHeight);
        return self.updateVisibility(shouldShowAssertion(isShowing, self));
      },
      setWindowSize(windowSize) {
        self.windowSize = windowSize || getWindowSize();
        return self.updateVisibility(shouldShowAssertion(isShowing, self));
      },
      updateVisibility(visible) {
        if (visible === 'open') {
          document.documentElement.classList.add('modalIsOpen');
        } else {
          document.documentElement.classList.remove('modalIsOpen');
        }
        return self;
      },
      onCancel(event) {
        event && event.stopPropagation();
        userCancel();
      },
    };
  });
